"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _Flex = _interopRequireDefault(require("../../../../components/shared-components/Flex"));

var _EllipsisDropdown = _interopRequireDefault(require("../../../../components/shared-components/EllipsisDropdown"));

var _icons = require("@ant-design/icons");

var _editDetails = _interopRequireDefault(require("./editDetails"));

// import { useHistory } from 'react-router';
// import utils from 'utils'
// const innerwidth = window.innerWidth;
// const { Option } = Select;
var CardData = function CardData(_ref) {
  var data = _ref.data;

  // const avatarSize = 50;
  // const history = useHistory();
  // const cl = localStorage.getItem("CL");
  // const token = localStorage.getItem("token");
  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      edit = _useState4[0],
      setEdit = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      editDetail = _useState6[0],
      setEditDetail = _useState6[1];

  var _useState7 = (0, _react.useState)(data),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      tableData = _useState8[0],
      setTableData = _useState8[1]; // useEffect(async () => {
  //     setTableData(data);
  //     setLoading(false);
  // }, [data]);


  (0, _react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setTableData(data);
                setLoading(false);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData(); // eslint-disable-next-line 
  }, [data]);

  var EditRM = function EditRM(detail) {
    setEdit(true);
    setEditDetail(detail);
  };

  var dropdownMenu = function dropdownMenu(elm) {
    return /*#__PURE__*/_react.default.createElement(_antd.Menu, null, /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, null, /*#__PURE__*/_react.default.createElement(_Flex.default, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "ml-2",
      onClick: function onClick() {
        return EditRM(elm);
      }
    }, /*#__PURE__*/_react.default.createElement(_icons.EditOutlined, {
      className: "mr-1"
    }), "Edit"))));
  };

  return loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "loading"
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, tableData.map(function (stu, index, elm) {
    return /*#__PURE__*/_react.default.createElement(_antd.Card, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
      justify: "center"
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
      xxl: 24
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "ml-md-4 w-100"
    }, /*#__PURE__*/_react.default.createElement(_Flex.default, {
      alignItems: "center",
      mobileFlex: false,
      className: "mb-3 text-md-left text-center"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "mb-0"
    }, stu.RM_Name))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_EllipsisDropdown.default, {
      menu: dropdownMenu(stu)
    }))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-muted"
    }, "RM code")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "font-weight-semibold"
    }, stu.RM_code)))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-muted"
    }, "Start Date")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "font-weight-semibold"
    }, stu.Today_Date ? stu.Today_Date : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
      xxl: 24
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-muted"
    }, "End Date")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "font-weight-semibold"
    }, stu.Date ? stu.Date : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
      xxl: 24
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-muted"
    }, "Attendance")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "font-weight-semibold"
    }, stu.Attendance ? stu.Attendance : "No Data")))))));
  }), edit ? /*#__PURE__*/_react.default.createElement(_editDetails.default, {
    item: editDetail,
    onCancel: function onCancel() {
      return setEdit(false);
    },
    showEdit: edit
  }) : "");
};

var _default = CardData;
exports.default = _default;